import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getCloudflareAnalytics } from '../services/cloudflareAnalytics';

/**
 * Hook providing analytics tracking with automatic page view tracking on route changes.
 * Offline: events are queued in IndexedDB and synced when the browser is back online.
 * Fire-and-forget; does not block the main thread or Map rendering.
 * No cookies or personal data — only in-app actions (e.g. search_used, favorite_added).
 */
export function useAnalytics() {
  const location = useLocation();

  useEffect(() => {
    getCloudflareAnalytics().trackEvent('page_view', { path: location.pathname });
  }, [location.pathname]);

  return {
    trackEvent: (name: string, data?: Record<string, unknown>) => {
      getCloudflareAnalytics().trackEvent(name, data);
    },
  };
}

/**
 * Alias for useAnalytics. Use this when you only need trackEvent (e.g. in components that track actions).
 * Same behavior: offline events go to IndexedDB and sync to the Worker on reconnect.
 */
export function useTrackEvent() {
  return useAnalytics();
}
